import React from 'react';
import { useIntl } from 'react-intl';

import Accordion from '@/components/switchback/Accordion/Accordion';
import Button, { ButtonVariants } from '@/components/switchback/Button/Button';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { ISitemapProps } from '@/pages/sitemap';

import css from './SitemapTemplate.module.css';

const SitemapTemplate: React.FC<ISitemapProps> = ({ title, contentBlocks }) => {
  const { isMobile } = useBreakpoint();
  const intl = useIntl();
  const displayAccordian = (isMobile: boolean) => {
    switch (isMobile) {
      case true: {
        return (
          <>
            {contentBlocks.map(
              (
                { value: { collapsed_text: collapsedText, displayed_text: displayedText } },
                index,
              ) => (
                <>
                  <Accordion
                    key={`mobile ${index}`}
                    id={`accordion`}
                    label={displayedText}
                    panelClassName={css.accordionPanel}>
                    <div dangerouslySetInnerHTML={{ __html: collapsedText }} />
                  </Accordion>
                  <hr className={css.horizontalSplit} />
                </>
              ),
            )}
          </>
        );
      }
      default: {
        return (
          <>
            {contentBlocks.map(
              (
                { value: { collapsed_text: collapsedText, displayed_text: displayedText } },
                index,
              ) => (
                <>
                  <div key={`non-mobile ${index}`} className={css.destinationContainer}>
                    <h5 className={css.destinationTitle}>{displayedText}</h5>
                    <div
                      className={css.destinationLinks}
                      dangerouslySetInnerHTML={{ __html: collapsedText }}
                    />
                  </div>
                </>
              ),
            )}
          </>
        );
      }
    }
  };

  return (
    <main className={css.main}>
      <h1 className={css.pageTitle}>{title}</h1>
      <section>
        {displayAccordian(isMobile)}
        {!isMobile && <hr />}
        <div className={css.cta}>
          <h4 className={css.ctaTitle}>
            {intl.formatMessage({
              defaultMessage: 'Ready for an unforgettable trip?',
              id: 'QIzTJJ',
            })}
          </h4>
          <Button
            className={css.ctaButton}
            href="/rv-search"
            variant={ButtonVariants.primaryOutlined}>
            {intl.formatMessage({ defaultMessage: 'Start searching', id: '7X4M54' })}
          </Button>
        </div>
      </section>
    </main>
  );
};

export default SitemapTemplate;
